export default __webpack_public_path__ + "static/media/plusIcon.16c2f6a3.svg";